// extracted by mini-css-extract-plugin
export var phone = "_54-0";